export const BASE_IMAGE_URL = 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/'

export const TAB_ICON_DIMENSIONS = {height : 28 , width : 28}
export const INTEREST_CALCULATOR_URL = 'https://voltmoney.in/interest-calculator-iframe?isMobileView=true&showOnlyDownload=true';
export const TNC_LINK = 'https://staging.voltmoney.in/terms?showHeader=false'
export const PRIVACY_POLICY_LINK = 'https://staging.voltmoney.in/privacy?showHeader=false'
